import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import CancelButton from '../../components/psc/lib/CancelButton';

import useAuthentication from '../../hooks/useAuthentication';
import useBrowserTabTitle from '../../hooks/useBrowserTabTitle';

const AccountUpdatePassword = () => {
    useBrowserTabTitle('Change Password')

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPassword2, setNewPassword2] = useState('');
    const [error, setError] = useState('');

    const navigate = useNavigate();

    const {
        currentUser,
        updateUser,
    } = useAuthentication();

    const handleSubmit = (event) => {
        event.preventDefault()

        if( newPassword !== newPassword2 ) {
            setError('The two new passwords do not match')
            return
        }

        if( newPassword.length < 10 ) {
            setError('The new password must be at least 10 characters')
            return
        }

        fetch('/v0/account/update_password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ current_password: currentPassword, new_password: newPassword }),
        })
        .then(res => {
            if( !res.ok ) {
                throw new Error(res.json());
            }
            return res.json()
        })
        .then(res => {
            updateUser(res.result);
            navigate('/main')
        })
        .catch(error => {
            // TODO - Read error message
            setError('Invalid current password')
       })
    }

    const requiredIndicator = (<label className="form-required-star">&nbsp;*</label>);

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>
                                Change Password
                            </h2>
                        </div>
                        <div className="ibox-content">
                            <form className="form-horizontal" onSubmit={handleSubmit}>
                                {currentUser.do_force_password_change &&
                                    <div className="form-group">
                                        <div className="alert alert-warning">
                                            For security - please choose a new password.
                                        </div>
                                    </div>
                                }

                                <div className="form-group">
                                    <label className="col-sm-2 control-label">Current Password
                                        {requiredIndicator}
                                    </label>
                                    <div className="col-sm-8">
                                        <input
                                            className="form-control"
                                            type="password"
                                            value={currentPassword}
                                            onChange={(e) => setCurrentPassword(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2 control-label"></label>
                                    <div className="col-sm-8">
                                        Your new password must be at least 10 characters long.
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2 control-label">New Password
                                        {requiredIndicator}
                                    </label>
                                    <div className="col-sm-8">
                                        <input
                                            className="form-control"
                                            type="password"
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-sm-2 control-label">New Password (again)
                                        {requiredIndicator}
                                    </label>
                                    <div className="col-sm-8">
                                        <input
                                            className="form-control"
                                            type="password"
                                            value={newPassword2}
                                            onChange={(e) => setNewPassword2(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="hr-line-dashed"></div>

                                <div className="form-group">
                                    {error && <div className="alert alert-danger">{error}</div>}

                                    <div className="col-sm-8 col-sm-offset-2">
                                        <CancelButton />

                                        <button className="btn btn-mr btn-primary" type="submit">Save Changes</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default AccountUpdatePassword
